export default [{
    path: '/',
    redirect: '/index',
},
{
    path: '*',
    component: resolve => require(['@/components/404'], resolve),
    meta: {
        title: '404'
    }
},
{
    path: '/index',
    component: resolve => require(['@/views/index'], resolve),
    meta: {
        title: '日照博物馆'
    }
},

]





// WEBPACK FOOTER //
// ./src/router/common.js